import ProjectPropertyLookup, {SourceType} from "./project-property-lookup";

export default class TaskTypesLookup extends ProjectPropertyLookup {

    get():ID[] {
        let res : ID[] = [];

        // 1. check if project has property and retrieve task types
        if (!!this.project.taskTypes) {
            res = this.getProjectTaskTypes(this.project);
            this.sourceType = SourceType.CUSTOM;
        }

        // 2. if task types not found yet check parents
        if (res.length === 0) {
            _.some(this.findAllParents(), project=>{
                res = this.getProjectTaskTypes(project);

                // if result found then inherited from current project
                if (res.length !== 0) {
                    this.sourceType = SourceType.INHERITED;
                    this.sourceProjectId = project.id;
                    return true; // break iteration loop
                }
            });
        }

        // 3. if task types still not found return default task types
        if (res.length === 0) {
            res = this.getDefaultTaskTypes();
            this.sourceType = SourceType.GENERIC;
        }

        return res;
    }

    getOptions() {
        // return task types as options items
        return _.map(this.get(), (id: ID)=>{
            const taskType = gd.session.taskTypes.get(id)!;
            return {
                value   : taskType.id,
                label   : taskType.name,
                icon    : taskType.icon,
            }
        });
    }

    getProjectTaskTypes(project: any) {
        let res: ID[] = [];

        // we do it because task types may not present in session or be deleted
        _.map(project.taskTypes, id=>{
            const taskType = gd.session.taskTypes.get(id);
            if (taskType && !taskType.isDeleted) res.push(id)
        });

        return res;
    }

    getDefaultTaskTypes() {
        return _(gd.session.taskTypes.filterByCompany(gd.companyId).models) // get all company task types
            .filter(taskType=>taskType.settings.isGeneric)          // filer all not generic task types
            .map(taskType=>taskType.id)                                     // return only task types ids
            .value();
    }
}